/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import Card from "react-bootstrap/Card";
import { Container, Row, Col } from 'reactstrap';
import img1 from '../../Images/img1.jpg'
import img2 from '../../Images/img2.jpg'
import img3 from '../../Images/img3.jpg'
import img4 from '../../Images/img4.jpg'
import img5 from '../../Images/img5.jpg'
import img6 from '../../Images/img6.jpg'
import img7 from '../../Images/img7.jpg'
import img8 from '../../Images/img8.jpg'

import Book from '../../Components/asserts/Book.pdf'
//import Very from '../CoursePages/Very'
// import {
//     BrowserRouter as Router,
//     Switch,
//     Route
//   } from "react-router-dom";

const Courses = () => {

    const [readMore, setReadMore] = useState(false);
    const extraContent1 = <div>
        <p className="extra-content">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Qui, consectetur neque ab
            porro quasi culpa nulla rerum quis minus voluptatibus sed hic ad quo sint, libero
            commodi officia aliquam! Maxime.
        </p>
    </div>

    const extraContent2 = <div>
        <p className="extra-content">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Qui, consectetur neque ab
            porro quasi culpa nulla rerum quis minus voluptatibus sed hic ad quo sint, libero
            commodi officia aliquam! Maxime.
        </p>
    </div>
    const linkName = readMore ? 'Read Less << ' : 'Read More >> '


    return (
        <Container>

            <Row>
                <Col>
                    <Card style={{
                        width: '20rem', padding: '20px',
                        margin: ' 50px auto',
                        display: ' grid',
                    }}>
                        <Card.Img variant="top" src={img1} />
                        <Card.Body>
                            <Card.Title>Coding landguages</Card.Title>
                            <Card.Text>
                                There are many distinct pleasures associated with computer programming. Craftsmanship has its quiet rewards, the satisfaction that comes from building a useful object and making it work. Excitement arrives with the flash of insight that cracks a previously intractable problem. The spiritual quest for elegance can turn the hacker into an artist. There are pleasures in parsimony, in squeezing the last drop of performance out of clever algorithms and tight coding.
                                <div className="App">
                                    <a className="read-more-link" onClick={() => { setReadMore(!readMore) }}><h6>{linkName}</h6></a>
                                    {readMore && extraContent1}
                                </div>
                            </Card.Text>
                            <Card.Link href="https://cutt.ly/3mNyxKp"><button style={{ padding: 'auto' }}>Amazon Link </button></Card.Link>
                            &nbsp;
                            {/* <Card.Link href="https://cutt.ly/3mNyxKp">Flipcart Link</Card.Link> */}
                            <button className="abc">
                                <a href={Book} className="abc1" download="Book.pdf" style={{ padding: '2px' }}>
                                    Download Link
                                </a>
                            </button>
                        </Card.Body>
                    </Card>


                </Col>

                <Col>
                    <Card style={{
                        width: '20rem', padding: '20px',
                        margin: ' 50px auto',
                        display: ' grid',
                    }}>
                        <Card.Img variant="top" src={img2} />
                        <Card.Body>
                            <Card.Title>Creating ASP.NET Core</Card.Title>
                            <Card.Text>
                                ASP.NET 4.5 Black Book is the one-time reference book, written from the programmer’s point of view, containing hundreds of examples and covering nearly every aspect of ASP.NET 4.5 in both VB and Chttps://cutt.ly/3mNyxKp. It will help you to master the entire spectrum of ASP.NET- from features of ASP.NET 4.5 to securing ASP.NET 4.5 pages, from standard and advance controls to CSS Style manager, from Web services to WCF services, from Web Parts Framework to AJAX, from XML to LINQ, from Silverlight to WPF, from COM + to RSS and Atom feed, and from IIS to CardSpace.
                                <div className="App">
                                    <a className="read-more-link" onClick={() => { setReadMore(!readMore) }}><h6>{linkName}</h6></a>
                                    {readMore && extraContent1}
                                </div>
                            </Card.Text>
                            <Card.Link href="https://cutt.ly/3mNyxKp"><button style={{ padding: 'auto' }}>Amazon Link </button></Card.Link>
                            &nbsp;
                            {/* <Card.Link href="https://cutt.ly/3mNyxKp">Flipcart Link</Card.Link> */}
                            <button className="abc">
                                <a href={Book} className="abc1" download="Book.pdf" style={{ padding: '2px' }}>
                                    Download Link
                                </a>
                            </button>
                        </Card.Body>
                    </Card>


                </Col>
                <Col>
                    <Card style={{
                        width: '20rem', padding: '20px',
                        margin: ' 50px auto',
                        display: ' grid',
                    }}>
                        <Card.Img variant="top" src={img3} />
                        <Card.Body>
                            <Card.Title>Programming Python</Card.Title>
                            <Card.Text>
                                Python is the most popular programming language for beginners because it's fun, powerful, and easy to learn. So why should your introductory Python book be long and tedious?

                                Python Crash Course gets you up and running with Python, teaching you the basics quickly so that you can solve problems, make things, and do cool stuff. Each chapter explains a new programming concept and includes a set of exercises to help reinforce your new knowledge.
                                <div className="App">
                                    <a className="read-more-link" onClick={() => { setReadMore(!readMore) }}><h6>{linkName}</h6></a>
                                    {readMore && extraContent1}
                                </div>
                            </Card.Text>
                            <Card.Link href="https://cutt.ly/3mNyxKp"><button style={{ padding: 'auto' }}>Amazon Link </button></Card.Link>
                            &nbsp;
                            {/* <Card.Link href="https://cutt.ly/3mNyxKp">Flipcart Link</Card.Link> */}
                            <button className="abc">
                                <a href={Book} className="abc1" download="Book.pdf" style={{ padding: '2px' }}>
                                    Download Link
                                </a>
                            </button>
                        </Card.Body>
                    </Card>


                </Col>
                <Col>
                    <Card style={{
                        width: '20rem', padding: '20px',
                        margin: ' 50px auto',
                        display: ' grid',
                    }}>
                        <Card.Img variant="top" src={img4} />
                        <Card.Body>
                            <Card.Title>Job Inteview Prep.</Card.Title>
                            <Card.Text>
                                Your CV is just a part of the job hunt. No matter how polished it looks and how awesome your work experience is, you'll be rejected if you bomb the interview - for example, by showing up late, coming unprepared or having no good questions to ask.

                                On the other hand, it's possible to have a modest CV but still land the job. So... how do you impress your future employer during the interview?



                                This complete collection of 4 books in 1 will walk you through all the steps of preparing for a job interview - no matter if it's your first or twentieth one. There are practical step-by-step exercises with questions and answers to fill out - go through them every day to make your preparation truly bulletproof!
                                <div className="App">
                                    <a className="read-more-link" onClick={() => { setReadMore(!readMore) }}><h6>{linkName}</h6></a>
                                    {readMore && extraContent1}
                                </div>
                            </Card.Text>
                            <Card.Link href="https://cutt.ly/3mNyxKp"><button style={{ padding: 'auto' }}>Amazon Link </button></Card.Link>
                            &nbsp;
                            {/* <Card.Link href="https://cutt.ly/3mNyxKp">Flipcart Link</Card.Link> */}
                            <button className="abc">
                                <a href={Book} className="abc1" download="Book.pdf" style={{ padding: '2px' }}>
                                    Download Link
                                </a>
                            </button>
                        </Card.Body>
                    </Card>


                </Col>
                <Col>
                    <Card style={{
                        width: '20rem', padding: '20px',
                        margin: ' 50px auto',
                        display: ' grid',
                    }}>
                        <Card.Img variant="top" src={img5} />
                        <Card.Body>
                            <Card.Title>Data Struc. & Algo.</Card.Title>
                            <Card.Text>
                                Learning about data structures and algorithms gives you a better insight on how to solve common programming problems. Most of the problems faced everyday by programmers have been solved, tried, and tested. By knowing how these solutions work, you can ensure that you choose the right tool when you face these problems.

                                This book teaches you tools that you can use to build efficient applications. It starts with an introduction to algorithms and big O notation, later explains bubble, merge, quicksort, and other popular programming patterns.
                                <div className="App">
                                    <a className="read-more-link" onClick={() => { setReadMore(!readMore) }}><h6>{linkName}</h6></a>
                                    {readMore && extraContent1}
                                </div>
                            </Card.Text>
                            <Card.Link href="https://cutt.ly/3mNyxKp"><button style={{ padding: 'auto' }}>Amazon Link </button></Card.Link>
                            &nbsp;
                            {/* <Card.Link href="https://cutt.ly/3mNyxKp">Flipcart Link</Card.Link> */}
                            <button className="abc">
                                <a href={Book} className="abc1" download="Book.pdf" style={{ padding: '2px' }}>
                                    Download Link
                                </a>
                            </button>
                        </Card.Body>
                    </Card>


                </Col>
                <Col>
                    <Card style={{
                        width: '20rem', padding: '20px',
                        margin: ' 50px auto',
                        display: ' grid',
                    }}>
                        <Card.Img variant="top" src={img6} />
                        <Card.Body>
                            <Card.Title>C++ Primer plus</Card.Title>
                            <Card.Text>
                                One book has always set the standard for C++ programmers: The C++ Programming Language, by Bjarne Stroustrup, the Bell Laboratories developer who created C++. Now, Stroustrup has updated this classic with clarifications based on reader feedback and new information in two brand-new appendices on ISO/ANSI C++: internationalization and exception safety. This makes The C++ Programming Language: Special Edition the only book with authoritative coverage of every important element of C++.
                                <div className="App">
                                    <a className="read-more-link" onClick={() => { setReadMore(!readMore) }}><h6>{linkName}</h6></a>
                                    {readMore && extraContent1}
                                </div>
                            </Card.Text>
                            <Card.Link href="https://cutt.ly/3mNyxKp"><button style={{ padding: 'auto' }}>Amazon Link </button></Card.Link>
                            &nbsp;
                            {/* <Card.Link href="https://cutt.ly/3mNyxKp">Flipcart Link</Card.Link> */}
                            <button className="abc">
                                <a href={Book} className="abc1" download="Book.pdf" style={{ padding: '2px' }}>
                                    Download Link
                                </a>
                            </button>
                        </Card.Body>
                    </Card>


                </Col>
                <Col>
                    <Card style={{
                        width: '20rem', padding: '20px',
                        margin: ' 50px auto',
                        display: ' grid',
                    }}>
                        <Card.Img variant="top" src={img7} />
                        <Card.Body>
                            <Card.Title>Job Interview Prep.</Card.Title>
                            <Card.Text>
                                Gayle laakmann McDowell is the founder and CEO of careercup and the author of cracking the PM interview and cracking the tech career. Her background is in software development. She has worked as a software engineer at Google, Microsoft, and Apple. At Google, she interviewed hundreds of software engineers and evaluated thousands of hiring packets on the hiring Committee. She holds a B.S.E. And M.S.E. In computer science from the University of Pennsylvania and an MBA from the Wharton school. She now consults with tech companies to improve their hiring process and with start-ups to prepare them for acquisition interviews.
                                <div className="App">
                                    <a className="read-more-link" onClick={() => { setReadMore(!readMore) }}><h6>{linkName}</h6></a>
                                    {readMore && extraContent1}
                                </div>
                            </Card.Text>
                            <Card.Link href="https://cutt.ly/3mNyxKp"><button style={{ padding: 'auto' }}>Amazon Link </button></Card.Link>
                            &nbsp;
                            {/* <Card.Link href="https://cutt.ly/3mNyxKp">Flipcart Link</Card.Link> */}
                            <button className="abc">
                                <a href={Book} className="abc1" download="Book.pdf" style={{ padding: '2px' }}>
                                    Download Link
                                </a>
                            </button>
                        </Card.Body>
                    </Card>


                </Col>
                <Col>
                    <Card style={{
                        width: '20rem', padding: '20px',
                        margin: ' 50px auto',
                        display: ' grid',
                    }}>
                        <Card.Img variant="top" src={img8} />
                        <Card.Body>
                            <Card.Title>React.js Beginner Guide</Card.Title>
                            <Card.Text>
                            The road to learn react teaches you the fundamentals of react. You will build a real world application along the way in plain react without complicated tooling. Everything from project setup to deployment on a server will be explained. The book comes with additional referenced reading material and exercises with each br>Chapter after reading the book, you will be able to build your own applications in react. The material is kept up to date by me and the community. In the road to learn react, I want to offer a foundation before you start to dive into the broader react ecosystem.
                            </Card.Text>
                            <div className="App">
                                <a className="read-more-link" onClick={() => { setReadMore(!readMore) }}><h6>{linkName}</h6></a>
                                {readMore && extraContent2}
                            </div>

                            <Card.Link href="https://cutt.ly/3mNyxKp"><button style={{ padding: 'auto' }}>Amazon Link </button></Card.Link>
                            &nbsp;
                            {/* <Card.Link href="https://cutt.ly/3mNyxKp">Flipcart Link</Card.Link> */}
                            <button className="abc">
                                <a href={Book} className="abc1" download="Book.pdf" style={{ padding: '2px' }}>
                                    Download Link
                                </a>
                            </button>
                        </Card.Body>
                    </Card>


                </Col>

            </Row>



        </Container>



    )
}

export default Courses;